/**
 * throughParams array,数组每个值为一个object
 * object param:
 * @param {field} [String] - 字段名称
 * @param {op} [String] - 规则
 * @param {type} [String] - 参数类型 [cParams / filtersParams]
 */
export const orderMenu = [
	{
		orderType: '平台报表',
		authority: '09_0001_0008_00',
		show: false,
		key: 'QUICK_SPXS_000001,REPORT_SPXS_000001,REPORT_SPKHMX_000001,REPORT_DHKHMX_000001,REPORT_WXSSPMX_000001',
		label: '商品销售统计表',
		path: 'goodMarketNew',
		throughPath: 'orderDetail',
		throughParams: [
			{ field: 'pName', op: 'cn', type: 'cParams' },
			{ field: 'pname', op: 'cn', type: 'cParams' },
			{ field: 'pCode', op: 'cn', type: 'cParams' },
			{ field: 'spec', op: 'cn', type: 'cParams' },
			{ field: 'specCode', op: 'cn', type: 'cParams' },
			{ field: 'orderstatus', op: 'eq', type: 'cParams' },
			{ field: 'giftFlag', op: 'eq', type: 'filtersParams' }
		]
	},
	{
		orderType: '平台报表',
		authority: '09_0001_0006_00',
		show: false,
		key: 'ORDER_MXDZ_000003',
		label: '主订单明细对账表',
		path: 'orderDetail',
		throughPath: 'childOrderDetail',
		throughParams: [
			{ field: 'ordernumber', op: 'cn', type: 'cParams' },
			{ field: 'customerName', op: 'cn', type: 'cParams' },
			{ field: 'orderstatus', op: 'eq', type: 'cParams' },
			{ field: 'giftFlag', op: 'eq', type: 'filtersParams' }
		]
	}, {
		orderType: '平台报表',
		authority: '09_0001_0007_00',
		show: false,
		key: 'ORDER_GYDZ_000004',
		label: '订单概要对账表',
		path: 'orderResume',
		throughPath: 'orderDetail',
		throughParams: [
			{ field: 'ordertype', op: 'eq', type: 'cParams' },
			{ field: 'ordernumber', op: 'cn', type: 'cParams' },
			{ field: 'customerName', op: 'cn', type: 'cParams' },
			{ field: 'liquidateflag', op: 'eq', type: 'cParams' }
		]
	}, {
		orderType: '平台报表',
		authority: '09_0001_0009_00',
		show: false,
		key: 'QUICK_KHXS_000002,REPORT_KHXS_000001,REPORT_KHSPMX_000001',
		label: '客户销售统计表',
		path: 'customSaleNew',
		throughPath: 'orderResume',
		throughParams: [
			{ field: 'customerName', op: 'cn', type: 'cParams' }
		]
	},
	{
		orderType: '平台报表',
		authority: '09_0001_0012_00',
		show: false,
		key: 'ORDER_MXDZ_000005',
		label: '子订单明细对账表',
		path: 'childOrderDetail',
		throughPath: '',
		throughParams: []
	},
	{
		orderType: '平台报表',
		authority: '09_0001_0010_00',
		show: false,
		key: 'REPORT_ORDER_PRODUCT_000001',
		label: '订单商品统计表',
		path: 'orderItem',
		throughPath: '',
		throughParams: []
	},
	{
		orderType: '平台报表',
		authority: '09_0001_0011_00',
		show: false,
		key: 'REPORT_REFUND_PRODUCT_000001',
		label: '退单商品统计表',
		path: 'refundOrderItem',
		throughPath: '',
		throughParams: []
	},
	{
		orderType: '平台报表',
		authority: '09_0001_0010_00',
		show: false,
		key: 'REPORT_ORDER_PRODUCT_000002',
		label: '订单商品统计表',
		path: 'orderItem1',
		throughPath: '',
		throughParams: []
	},
	{
		orderType: '平台报表',
		authority: '09_0001_0010_00',
		show: false,
		key: 'REPORT_ORDER_PRODUCT_000003',
		label: '订单商品统计表',
		path: 'orderItem2',
		throughPath: '',
		throughParams: []
	},
	{
		orderType: '平台报表',
		authority: '09_0001_0011_00',
		show: false,
		key: 'REPORT_REFUND_PRODUCT_000002',
		label: '退单商品统计表',
		path: 'refundOrderItem1',
		throughPath: '',
		throughParams: []
	},
	{
		orderType: '平台报表',
		authority: '09_0001_0011_00',
		show: false,
		key: 'REPORT_REFUND_PRODUCT_000003',
		label: '退单商品统计表',
		path: 'refundOrderItem2',
		throughPath: '',
		throughParams: []
	},
	{
		orderType: '平台报表',
		authority: '09_0003_0001_00',
		show: false,
		key: 'PAY_ZFDZ_000006',
		label: '单据支付对账明细表',
		path: 'orderPayment',
		throughPath: 'orderResume',
		throughParams: [
			{ field: 'ordernumber', op: 'cn', type: 'filtersParams' },
			{ field: 'refundnumber', op: 'cn', type: 'filtersParams' }
		]
	},
	{
		orderType: '平台报表',
		authority: '09_0003_0002_00',
		show: false,
		key: 'PAY_ZFLS_000007,PAY_ZFLS_000008',
		label: '支付流水报表',
		path: 'transactionNew',
		throughPath: 'orderResume',
		throughParams: [
			{ field: 'ordernumber', op: 'cn', type: 'cParams' }
		]
	},
	{
		orderType: '平台报表',
		authority: '09_0003_0003_00',
		show: false,
		key: 'PREPAY_YFMX_000008',
		label: '预付货款明细表',
		path: 'paymentAdvance',
		throughPath: '',
		throughParams: []
	},
	{
		orderType: '平台报表',
		authority: '09_0003_0004_00',
		show: false,
		key: 'REPORT_YEDZ_000001',
		label: '预付货款余额查询表',
		path: 'balance',
		throughPath: '',
		throughParams: []
	},
	{
		orderType: '平台报表',
		// authority: '09_0003_0004_00',
		show: false,
		key: 'REPORT_DDZF_000001',
		label: '订单支付对账表',
		path: 'orderPay',
		throughPath: '',
		throughParams: []
	},
	{
		orderType: '平台报表',
		key: 'REPORT_DDCY_000001',
		label: '订单支付流水对账明细表',
		path: 'OrderPayDetail',
		show: true,
		throughPath: '',
		throughParams: []
	},
	{
		orderType: '营销活动报表',
		authority: '09_0004_0001_00',
		key: 'REPORT_YHQTJ_000001',
		label: '优惠券统计表',
		path: 'couponStatistics',
		throughPath: 'couponDetail',
		throughParams: [
			{ field: 'name', op: 'cn', type: 'filtersParams' },
			{ field: 'customername', op: 'cn', type: 'filtersParams' }
		]
	},
	{
		orderType: '营销活动报表',
		authority: '09_0004_0002_00',
		key: 'REPORT_YHQMX_000001',
		label: '优惠券明细表',
		path: 'couponDetail',
		throughPath: '',
		throughParams: []
	}
	// {
	// 	orderType: '平台报表',
	// 	authority: '09_0001_0001_00',
	// 	show: false,
	// 	key: 'DPXQ_121011',
	// 	label: '单据详情报表',
	// 	path: 'orderDetail',
	// 	throughPath: '',
	// 	throughParams: []
	// }, {
	// 	orderType: '平台报表',
	// 	authority: '09_0001_0002_00',
	// 	key: 'DPDD_121010',
	// 	show: false,
	// 	label: '单据销售汇总表',
	// 	path: 'saleOrder',
	// 	throughPath: 'orderDetail',
	// 	throughParams: [
	// 		{ field: 'orderNo', op: 'cn', type: 'cParams' },
	// 		{ field: 'orderType', op: 'eq', type: 'cParams' },
	// 		{ field: 'buyerName', op: 'cn', type: 'filtersParams' },
	// 		{ field: 'shopName', op: 'cn', type: 'filtersParams' }
	// 	]
	// }, {
	// 	orderType: '平台报表',
	// 	authority: '09_0001_0003_00',
	// 	show: false,
	// 	key: 'DPHZ_121040',
	// 	label: '店铺销售汇总表',
	// 	path: 'shopSummary',
	// 	throughPath: 'saleOrder',
	// 	throughParams: [
	// 		{ field: 'entname', op: 'cn', type: 'filtersParams' },
	// 		{ field: 'shopName', op: 'cn', type: 'filtersParams' }
	// 	]
	// }, {
	// 	orderType: '平台报表',
	// 	authority: '09_0001_0004_00',
	// 	show: false,
	// 	key: 'SHHZ_111040',
	// 	label: '商户销售汇总表',
	// 	path: 'businessSummary',
	// 	throughPath: 'shopSummary',
	// 	throughParams: [
	// 		{ field: 'entname', op: 'cn', type: 'filtersParams' }
	// 	]
	// }, {
	// 	orderType: '平台报表',
	// 	authority: '09_0001_0005_00',
	// 	show: false,
	// 	key: 'SPXS_131040',
	// 	label: '商品销售汇总表',
	// 	path: 'businessPurchase',
	// 	throughPath: 'shopSummary',
	// 	throughParams: []
	// }, {
	// 	orderType: '平台报表',
	// 	authority: '09_0002_0002_00',
	// 	show: false,
	// 	key: 'HDMX_222222',
	// 	label: '活动明细表',
	// 	path: 'activityDetail',
	// 	throughPath: '',
	// 	throughParams: []
	// }, {
	// 	orderType: '平台报表',
	// 	authority: '09_0002_0001_00',
	// 	show: false,
	// 	key: 'SPXS_13100011',
	// 	label: '活动类型汇总表',
	// 	path: 'activitySummary',
	// 	throughPath: 'activityDetail',
	// 	throughParams: [
	// 		{ field: 'type', op: 'eq', type: 'filtersParams' },
	// 		{ field: 'orderName', op: 'cn', type: 'filtersParams' },
	// 		{ field: 'orderCode', op: 'cn', type: 'filtersParams' }
	// 	]
	// }
]

